// @ts-nocheck
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import classNames from 'classnames';
import { CLASSES } from '@/constants/classes';

import UsersActions from '@/containers/Preferences/Users/UsersActions';
import CurrenciesActions from '@/containers/Preferences/Currencies/CurrenciesActions';
import WarehousesActions from '@/containers/Preferences/Warehouses/WarehousesActions';
import BranchesActions from '@/containers/Preferences/Branches/BranchesActions';
import withDashboard from '@/containers/Dashboard/withDashboard';

import { compose } from '@/utils';

import '@/style/pages/Preferences/Topbar.scss';
import SalesPeopleActions from '@/containers/Preferences/SalesPeople/SalesPeopleActions';
import CarriersActions from '@/containers/Preferences/Carriers/CarriersActions';
import LogoLibraryActions from '@/containers/Preferences/LogoLibrary/LogoLibraryActions';
import ShippingAccountsActions from '@/containers/Preferences/ShippingAccount/ShippingAccountsActions';
import ShipMethodsActions from '@/containers/Preferences/ShipMethods/ShipMethodActions';

/**
 * Preferences topbar.
 */
function PreferencesTopbar({ preferencesPageTitle }) {
  return (
    <div
      className={classNames(
        CLASSES.PREFERENCES_PAGE_TOPBAR,
        CLASSES.PREFERENCES_TOPBAR,
      )}
    >
      <div class="preferences-topbar__title">
        <h2>{preferencesPageTitle}</h2>
      </div>
      <div class="preferences-topbar__actions">
        <Route pathname="/preferences">
          <Switch>
            <Route exact path={'/preferences/users'} component={UsersActions} />
            <Route
              exact
              path={'/preferences/currencies'}
              component={CurrenciesActions}
            />
            <Route
              exact
              path={'/preferences/salespeople'}
              component={SalesPeopleActions}
            />
            <Route
              exact
              path={'/preferences/carriers'}
              component={CarriersActions}
            />
            <Route
              exact
              path={'/preferences/warehouses'}
              component={WarehousesActions}
            />
            <Route
              exact
              path={'/preferences/branches'}
              component={BranchesActions}
            />
            <Route
              exact
              path={'/preferences/logo-library'}
              component={LogoLibraryActions}
            />
            <Route
              exact
              path={'/preferences/shipping-accounts'}
              component={ShippingAccountsActions}
            />
            <Route
              exact
              path={'/preferences/ship-methods'}
              component={ShipMethodsActions}
            />
          </Switch>
        </Route>
      </div>

    </div>
  );
}

export default compose(
  withDashboard(({ preferencesPageTitle }) => ({ preferencesPageTitle })),
)(PreferencesTopbar);